module.exports = __webpack_public_path__ + "static/img/Vision.5d8a69d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Vision.png
// module id = 16Bp
// module chunks = 1